import React from 'react'

function PlacePromotion() {
  return (
    <div>PlacePromotion</div>
  )
}

export default PlacePromotion